// src/api/accountingReports.js
import axios from 'axios';

const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

// comments: English only
// Finance Summary page uses this endpoint now:
// GET {apiUrl}/accounting/finance/summary?from=YYYY-MM-DD&to=YYYY-MM-DD&bucket=monthly
export const fetchSummary = (params) =>
  axios.get(`${apiUrl}/accounting/finance/summary`, { params });

// Keep the existing endpoints as-is for now (until you migrate them in backend)
export const fetchHorseLedger = (params) =>
  axios.get(`${apiUrl}/accounting-reports/horse-ledger`, { params });

export const fetchClientStatements = (params) =>
  axios.get(`${apiUrl}/accounting-reports/client-statements`, { params });

export const fetchAccommodationKPIs = (params) =>
  axios.get(`${apiUrl}/accounting-reports/accommodation-kpis`, { params });

export const fetchTransportKPIs = (params) =>
  axios.get(`${apiUrl}/accounting-reports/transport-kpis`, { params });
